import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const InnovatorIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M8.75 18.75H11.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9.99982C15.0033 9.0639 14.7439 8.14583 14.2513 7.35006C13.7586 6.55428 13.0525 5.91276 12.2133 5.49847C11.374 5.08418 10.4353 4.91376 9.50404 5.00659C8.57273 5.09943 7.68617 5.4518 6.94523 6.02361C6.20429 6.59542 5.63871 7.36371 5.31285 8.24108C4.98698 9.11844 4.91392 10.0697 5.10196 10.9865C5.29 11.9033 5.73159 12.749 6.37651 13.4273C7.02142 14.1055 7.84376 14.5892 8.74997 14.8232V16.2498H11.25V14.8232C12.3213 14.5486 13.271 13.9259 13.9498 13.0528C14.6286 12.1797 14.998 11.1057 15 9.99982Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 2.5V1.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 8.75H18.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 10H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3027 14.6782L16.1869 15.5624"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.8125 3.1875L4.69667 4.07167"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3027 4.07167L16.1869 3.1875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.8125 15.5624L4.69667 14.6782"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
